var _rect, _path, _path2, _path3, _ellipse, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabaseError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  rx: 48,
  fill: "#F3F3F4"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48 63C54.6274 63 60 61.9152 60 60.5769V54.5C60 53.3954 59.1046 52.5 58 52.5H38C36.8954 52.5 36 53.3954 36 54.5V60.5769C36 61.9152 41.3726 63 48 63Z",
  fill: "white",
  stroke: "#92999E",
  strokeWidth: 1.25
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 54C54.6274 54 60 52.9152 60 51.5769V45.5C60 44.3954 59.1046 43.5 58 43.5H38C36.8954 43.5 36 44.3954 36 45.5V51.5769C36 52.9152 41.3726 54 48 54Z",
  fill: "white",
  stroke: "#92999E",
  strokeWidth: 1.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M48 45C54.6274 45 60 43.9152 60 42.5769V34.65C60 34.5672 59.9328 34.5 59.85 34.5H36.15C36.0672 34.5 36 34.5672 36 34.65V42.5769C36 43.9152 41.3726 45 48 45Z",
  fill: "white",
  stroke: "#92999E",
  strokeWidth: 1.25
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 48,
  cy: 34.5,
  rx: 12,
  ry: 1.5,
  fill: "white",
  stroke: "#92999E",
  strokeWidth: 1.25
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.2934 50.7926C59.0733 49.5164 60.9267 49.5164 61.7066 50.7926L69.1404 62.9571C69.9549 64.2898 68.9957 66 67.4339 66H52.5661C51.0043 66 50.0451 64.2898 50.8596 62.9571L58.2934 50.7926Z",
  fill: "#E67D2D"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M60 56L60 59",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 61.75,
  r: 0.75,
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabaseError);
export default ForwardRef;